import { useQuery } from "@tanstack/react-query";
import type { QueryOpts } from "~api/helpers.ts";
import { tenantKeys } from "~api/tenants.ts";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import type { PhotoDocWorkPackage } from "~generated";
import { PhotoDocumentationService } from "~generated";

// Kept apart from photoUpload.ts so the offline prefetch does not drag dexie into the start graph
const photoUploadKeys = {
  base: (tenantId: string) =>
    [
      ...tenantKeys.detail(tenantId),
      "photo_documentation",
      "photo_upload",
      "v1",
    ] as const,
  workPackages: (tenantId: string) =>
    [...photoUploadKeys.base(tenantId), "work_packages"] as const,
};

export function usePhotoUploadWorkPackages(
  options?: QueryOpts<
    PhotoDocWorkPackage[],
    ReturnType<typeof photoUploadKeys.workPackages>
  >,
) {
  const currentTenant = useCurrentTenant();

  return useQuery({
    ...options,
    queryKey: photoUploadKeys.workPackages(currentTenant.id),
    queryFn: async () => {
      const data = await PhotoDocumentationService.getPhotoDocWorkPackages(
        currentTenant.id,
      );
      return data.work_packages;
    },
  });
}
